import {
  useActivityWorkflowActions,
  useCurrentActivities,
  useCurrentActivity,
} from "@hydrologiq/shared/contexts/ActivityWorkflowContextV2"
import { ActivityEditProps } from "./screens"
import ActivitiesDetailsEditor from "../ActivityDetailsEditor"
import ActivityScreenWrapper from "./ActivityScreenWrapper"
import ActivityLoading from "./ActivityLoading"

interface ActivityEditDetailsProps extends ActivityEditProps {}

const ActivityEditDetails = ({ onBack, onChange }: ActivityEditDetailsProps) => {
  const activity = useCurrentActivity()
  const activities = useCurrentActivities()
  const { needToRefresh } = useActivityWorkflowActions()
  if (!activity || !activities) {
    return <ActivityLoading />
  }

  return (
    <ActivityScreenWrapper>
      <ActivitiesDetailsEditor
        activity={activity}
        key={activity.assets?.[0]?.id}
        onSuccess={() => {
          needToRefresh()
          onChange()
        }}
        onCancel={onBack}
      />
    </ActivityScreenWrapper>
  )
}

export default ActivityEditDetails
